"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogContentOverrides = void 0;
var createMuiDialogContentOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(9, 12, 4),
            "&:first-child": {
                paddingTop: spacing(12),
            },
            "&:last-child": {
                paddingBottom: spacing(12),
            },
        },
    });
};
exports.createMuiDialogContentOverrides = createMuiDialogContentOverrides;
//# sourceMappingURL=MuiDialogContent.js.map